import { lazy, Suspense } from 'react'
import Loader from '../custom/loader/main';

const Main = lazy(() => import('../components/setup/directorate/main'));

const Directorate = () => {
  return (
    <Suspense fallback={<Loader/>}>
      <Main/>
    </Suspense>
  )
}

export default Directorate;